<template>
  <div>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" @click="$router.push('/admon')" style="cursor: pointer">Administración</li>
            <li class="breadcrumb-item active" aria-current="page">Estados de Cuenta</li>
        </ol>
    </nav>
    <div class="container-fluid">
      <vx-card title="Estados de cuenta" class="mt-5" subtitle="Selecciona las opciones necesarias y presiona el botón 'Generar'">
          <vs-row>
            <vs-col vs-lg="2" vs-sm="6" vs-xs="12">
                <vs-select
                    class="w-full mb-5"
                    label="Tipo"
                    v-model.lazy="type"
                    name="type"
                    placeholder="Selecciona el tipo"
                >
                    <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item,index) in types"
                    class="w-full"
                    />
                </vs-select>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="6" vs-xs="12" class="ml-2">
                  <label>ID del {{(type == 0 ? 'inversionista' : 'proyecto')}}</label>
                  <vs-input class="w-full" v-model="id" type="number" min=1 :disabled="loading"/>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="6" vs-xs="12" class="ml-2">
                <vs-select
                    class="w-full mb-5"
                    label="Mes de corte"
                    v-model.lazy="periodSelected"
                    name="periodSelected"
                    placeholder="Seleccione una opción"
                >
                    <vs-select-item
                    :key="index"
                    :value="index+1"
                    :text="item"
                    v-for="(item,index) in months"
                    class="w-full"
                    />
                </vs-select>
            </vs-col>
            <vs-col vs-lg="2" vs-sm="6" vs-xs="12" class="ml-2">
                <vs-select
                    class="w-full mb-5"
                    label="Año"
                    v-model.lazy="yearSelected"
                    name="yearSelected"
                    placeholder="Seleccione una opción"
                >
                    <vs-select-item
                    :key="index"
                    :value="index"
                    :text="item"
                    v-for="(item,index) in years"
                    class="w-full"
                    />
                </vs-select>
            </vs-col>
            <!-- <vs-col vs-lg="2" vs-sm="6" vs-xs="12" class="ml-2">
                <vs-select
                    class="w-full mb-5"
                    label="Meses a generar"
                    v-model.lazy="quantityMonthsSelected"
                    name="quantityMonthsSelected"
                    placeholder="Seleccione una opción"
                >
                    <vs-select-item
                    :key="index"
                    :value="item"
                    :text="item"
                    v-for="(item,index) in quantityMonths"
                    class="w-full"
                    />
                </vs-select>
            </vs-col> -->
          </vs-row>
          <vs-row>
            <vs-col vs-xs="12">
              <div class="flex flex-wrap">
                <vs-button color="dark" @click="loadStatements()" :disabled="loading || id == null">Consultar</vs-button>
                <!-- <vs-button color="success" class="ml-2" @click="generateStatement()" :disabled="loading || id == null">Generar</vs-button> -->
              </div>
            </vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="12">
              <h5 class="bold mt-5">Estados de cuenta generados</h5>
              <vs-table
                :sst="true"
                @sort="handleSort"
                ref="table"
                stripe
                :max-items="30"
                :data="allStatements"
                noDataText="No hay datos disponibles"
                class="w-full"
              >
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                  <div class="pager" v-if="allStatements.length > 0">
                    <div class="flex flex-wrap">
                      <vs-button
                        :disabled="allData.prev_page_url ? null:true"
                        type="border"
                        radius
                        @click="pager(allData.prev_page_url)"
                        class="mr-2"
                        icon-pack="feather"
                        icon="icon-chevron-left"
                      ></vs-button>
                      <vs-button
                        v-if="allData.prev_page_url != null"
                        text-color="#212121"
                        type="flat"
                        radius
                        @click="pager(allData.first_page_url)"
                        class="rounded-circle mr-2"
                      >
                        <strong>1 ..</strong>
                      </vs-button>
                      <vs-button type="flat" text-color="dark" radius class="mr-2">
                        <strong>{{ allData.current_page }}</strong>
                      </vs-button>
                      <vs-button
                        v-if="allData.next_page_url != null"
                        text-color="#212121"
                        type="flat"
                        radius
                        @click="pager(allData.last_page_url)"
                        class="rounded-circle mr-2"
                      >
                        <strong>.. {{ allData.last_page }}</strong>
                      </vs-button>
                      <vs-button
                        :disabled="allData.next_page_url ? null:true"
                        type="border"
                        radius
                        @click="pager(allData.next_page_url)"
                        class="mr-2"
                        icon-pack="feather"
                        icon="icon-chevron-right"
                      ></vs-button>
                    </div>
                  </div>
                  <!-- ITEMS PER PAGE -->
                  <div
                    v-if="totalRecords > 0"
                    class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2">{{ from }} - {{ to }} de {{ totalRecords }}</span>
                  </div>
                </div>
                <template slot="thead">
                  <vs-th
                    class="bold"
                    v-for="(col, idx) in columns"
                    v-bind:key="idx"
                    :sort-key="col.sortable ? col.key : null"
                  >{{col.title}}</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                    <vs-td>{{ midDateFormat(tr.start_period_date) }}</vs-td>
                    <vs-td>{{ midDateFormat(tr.end_period_date) }}</vs-td>
                    <vs-td><vs-button size="small" color="primary" type="filled" @click="downloadStatement(tr.id)">Descargar</vs-button></vs-td>
                  </vs-tr>
                </template>
              </vs-table>          
            </vs-col>
          </vs-row>
      </vx-card>
    </div>
  </div>
</template>

<script lang="js">
  import dateHelper from "@mixins/dateHelper";
  const columnDefinitions = [
    { title: "Inicio del periodo", key: "start_period_date", sortable: true },
    { title: "Fin del periodo", key: "end_period_date", sortable: true },
    { title: "Archivo", key: "file", sortable: false },
  ];

  export default  {
    name: 'statements',
    props: [],
    mixins: [dateHelper],
    data() {
      return {
        id: null,
        type:0,
        periodSelected: 1,
        yearSelected: 0,
        quantityMonthsSelected: 1,
        loading: false,
        quantityMonths: [1,2,3,4,5],
        months: ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
        years: ["2020","2021","2022","2023"],
        types: [
            { text: "Inversionista", value: 0 },
            { text: "Proyecto", value: 1 },
        ],
        allData: {
          data: [],
          from: null,
          to: null,
          total: 0
        },
        columns: columnDefinitions,
      }
    },
    computed: {
      allStatements() {
        return this.allData.data;
      },
      from() {
        return this.allData.from;
      },
      to() {
        return this.allData.to;
      },
      totalRecords() {
        return this.allData.total;
      }
    },
    methods: {
      async generateStatement(){
        this.showLoading(true);
        this.loading = true 
         try{
          var response = await axios.post('/api/generate-statement', {
            id: this.id,
            type: this.type,
            period: this.periodSelected,
            quantityMonths: this.quantityMonthsSelected,
            year: this.years[this.yearSelected],
          });
          this.successNotif("Aviso", 'Estado de cuenta generado.', 4000);
          this.loading = false;
          this.showLoading(false);
          await this.loadStatements();
        }catch(e){
          this.errorNotif("Aviso", e.response.data.message, 4000);
          this.loading = false;
          this.showLoading(false);
        }
      },
      async loadStatements(url = `/api/statements-created/${this.type}/${this.id}`) {
        this.showLoading(true);
        try {
          const response = await axios.get(url);
          this.allData = response.data;
          this.showLoading(false);
        } catch (e) {          
          this.showLoading(false);
          this.errorNotif("Aviso", e.response.data.message, 4000);
        }
      },
      downloadStatement(statementId) {
          window.open(`${this.ApiDomain}/api/downloadStatement/${this.type}/${statementId}?access_token=${this.AccessToken}`, "_blank");                
      },
      async handleSort(key, active) {
        switch (key) {
          case "start_period_date":
            this.allStatements.sort(function (a, b) {
              return (
                Number(new Date(a.start_period_date)) - Number(new Date(b.start_period_date))
              );
            });
            break;
          case "end_period_date":
            this.allStatements.sort(function (a, b) {
              return (
                Number(new Date(a.end_period_date)) - Number(new Date(b.end_period_date))
              );
            });
            break;
          default:
            break;
        }
      },
      async pager(url) {
        await this.loadStatements(this.startDate, this.endDate, url);
      },
    }
}
</script>